"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3493],{

/***/ 38210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ SiteLogoImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var SiteLogoImage = function(param) {
    var _width = param.width, width = _width === void 0 ? 32 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, className = param.className;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
        src: "/static/icons/1024x1024.png",
        className: className,
        width: width,
        height: height,
        quality: 100
    });
};


/***/ }),

/***/ 23493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/shared-site/logo-image.tsx
var logo_image = __webpack_require__(38210);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./site-v2/shared/header.tsx





var Header = function() {
    var ref = (0,react.useState)(true), top1 = ref[0], setTop = ref[1];
    // detect whether user has scrolled the page down by 10px
    (0,react.useEffect)(function() {
        var scrollHandler = function() {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener('scroll', scrollHandler);
        return function() {
            return window.removeEventListener('scroll', scrollHandler);
        };
    }, [
        top1
    ]);
    var scrollToAnchor = function(event) {
        var target = event.currentTarget.getAttribute('href');
        var targetElement = document.querySelector(target);
        if (targetElement) {
            event.preventDefault();
            var top = targetElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: top,
                behavior: 'smooth'
            });
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (0,clsx_m/* default */.Z)('fixed w-full z-30 transition duration-300 ease-in-out transform-gpu', !top1 && 'bg-bluegray-900 bg-opacity-50 backdrop-blur-sm shadow-lg'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-6xl mx-auto px-5 sm:px-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between h-16 md:h-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/home",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex items-center space-x-4",
                                "aria-label": "Reflect",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "shadow-sm w-[38px] h-[38px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_image/* SiteLogoImage */.n, {
                                            width: 38,
                                            height: 38
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-xl font-extrabold tracking-wide",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bg-clip-text text-transparent bg-gradient-to-r from-[#ECE4FF] to-white",
                                            children: "Reflect"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 justify-center space-x-5 hidden md:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#product",
                                onClick: scrollToAnchor,
                                className: "text-sm font-semibold text-[#ECE5FF] hover:text-white transition duration-200",
                                children: "Product"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#pricing",
                                onClick: scrollToAnchor,
                                className: "text-sm font-semibold text-[#ECE5FF] hover:text-white transition duration-200",
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#company",
                                onClick: scrollToAnchor,
                                className: "text-sm font-semibold text-[#ECE5FF] hover:text-white transition duration-200",
                                children: "Company"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 flex justify-end items-center space-x-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/auth",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex-none text-sm font-semibold text-[#ECE5FF] hover:text-white transition duration-200",
                                    children: "Login"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/checkout?confirm=true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex-none inline-block text-sm font-semibold text-white bg-gradient-to-b from-home-button-lg to-home-button-rg rounded-lg drop-shadow-lg px-4 py-2 shadow-inner-white transform active:translate-y-0.5 active:opacity-90 transition duration-100",
                                    children: "Start Free Trial"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./site-v2/home/footer.tsx




var Footer = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "px-6 py-16 space-y-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/static/home/footer-logo.png",
                    width: 768 / 2,
                    height: 480 / 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-6xl mx-auto text-center flex flex-col items-center space-y-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "flex space-x-6 text-white text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/discord",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Discord"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "https://twitter.com/reflectnotes",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Twitter"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/downloads",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Downloads"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/terms",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Terms"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/privacy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Privacy"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm text-[#B1B2DD]",
                        children: "Reflect App, LLC. All rights reserved."
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./site-v2/home/hero/app-preview.tsx


var PREVIEW_MOVIE_SRC = 'https://cleanshot-cloud-fra.accelerator.net/media/15712/Wz2lWJffWyHHBGWDE8CW3Dqd3Dcv5C7wfDqxVjES.mp4';
var AppPreview = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative rounded-lg overflow-hidden bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            preload: "auto",
            autoPlay: true,
            playsInline: true,
            muted: true,
            poster: "/static/home/app-preview.png",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: PREVIEW_MOVIE_SRC,
                type: "video/mp4"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./site-v2/home/hero.tsx




var Hero = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 pointer-events-none z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/static/home/hero-bg.png",
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-20 md:pt-40 relative z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-3xl md:text-6xl font-bold leading-tight tracking-tight",
                            "data-aos": "zoom-y-out",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bg-clip-text text-transparent bg-gradient-to-r from-[#C3D4FF] via-white to-[#CFBCFF]",
                                children: "Think better with Reflect"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg md:text-xl leading-8 text-white text-opacity-70 mb-8",
                                "data-aos": "zoom-y-out",
                                "data-aos-delay": "150",
                                children: "Keep track of your notes, books, and meetings."
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center items-center md:pt-20 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-5xl relative z-10 px-5 transform-gpu",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-5 pointer-events-none z-0 rounded-md",
                                style: {
                                    boxShadow: '0 -40px 200px rgba(0, 102, 255, 0.5), 0 40px 200px rgba(56, 243, 255, 0.5)'
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppPreview, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 pointer-events-none z-0 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: "/static/home/hero-stars.png",
                            width: 1225,
                            height: 445,
                            layout: "intrinsic"
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./site-v2/home/icons/browser.tsx


var BrowserIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 5H8a3 3 0 00-3 3v24a3 3 0 003 3h24a3 3 0 003-3V8a3 3 0 00-3-3z",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 9h.01M12 9h.01M15 9h.01",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 26v-3h12v3H14z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M13 19h-1a2 2 0 00-2 2v1m17-3h1a2 2 0 012 2v1M13 30h-1a2 2 0 01-2-2v-1m17 3h1a2 2 0 002-2v-1",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/calendar.tsx


var CalendarIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32 8H8a3 3 0 00-3 3v21a3 3 0 003 3h24a3 3 0 003-3V11a3 3 0 00-3-3z",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 11a3 3 0 013-3h24a3 3 0 013 3v3H5v-3z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 5v4M29 5v4",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 22v-2h2v2h-2zM10 29v-2h2v2h-2zM16 22v-2h2v2h-2zM16 29v-2h2v2h-2z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M22 22v-2h2v2h-2z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 29v-2h2v2h-2zM28 22v-2h2v2h-2z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/encrypted.tsx


var EncryptedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 19v-3a5 5 0 00-5-5v0a5 5 0 00-5 5v3",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 26a3 3 0 003 3h8a3 3 0 003-3v-6H13v6z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 35H9a4 4 0 01-4-4V9a4 4 0 014-4h22a4 4 0 014 4v22a4 4 0 01-4 4h-2",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M15 35h10",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/ios-app.tsx


var IosAppIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27 14V8a3 3 0 00-3-3H8a3 3 0 00-3 3v24a3 3 0 003 3h16a3 3 0 003-3v-7",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 21v-3h14v3H21z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M9 14v-3h14v3H9z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 5l-2 2h-4l-2-2",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/kindle-import.tsx


var KindleImportIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27 8V6a1 1 0 00-1-1H6a1 1 0 00-1 1v28a1 1 0 001 1h20a1 1 0 001-1V20",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 32a3 3 0 003 3h16a3 3 0 003-3v-1H5v1z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 26v-2h12v2H10z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M10 20h12",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 14h10",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35 14l-4-3v6l4-3z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 33h2",
                stroke: "#080624",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/networked.tsx


var NetworkedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: 20,
                cy: 20,
                r: 13,
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M20 18a2 2 0 110 4 2 2 0 010-4z",
                fill: "#080624",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 5a2 2 0 110 4 2 2 0 010-4zM20 31a2 2 0 110 4 2 2 0 010-4zM33 18a2 2 0 110 4 2 2 0 010-4zM7 18a2 2 0 110 4 2 2 0 010-4z",
                fill: "#080624",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/publishing.tsx


var PublishingIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 17v18l5-7h9L18 17z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M20 5v2",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.5 7.01l-1 1.732M32.99 12.5l-1.732 1M35 20h-2M8.742 26.5l-1.732 1M7 20H5",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M8.742 13.5l-1.732-1M13.5 8.742l-1-1.732",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/speed.tsx


var SpeedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27 23c2.726-.566 5-3.106 5-6a6 6 0 00-6-6 6 6 0 00-12 0 6 6 0 00-6 6c0 2.88 2.292 5.42 5 6",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M13 35v-3h14v3H13z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 28V18",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 17l-3 4h6l-3-4z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/features.tsx










var Features = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex justify-center items-center my-10 md:my-24 px-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 gap-y-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "Built for speed",
                    description: "Syncronized in real-time between all your devices.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeedIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "Networked notes",
                    description: "Backlink notes to each other to form a graph of ideas.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NetworkedIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "iOS app",
                    description: "Capture ideas on the go, online or offline.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IosAppIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "End-to-end encryption",
                    description: "Super secure. Only you have access to your data.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EncryptedIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "Calendar integration",
                    description: "Add people and meetings from Google Calendar.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "Publishing",
                    description: "One-click publishing to the web.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishingIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "Kindle import",
                    description: "Sync your book highlights and notes.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KindleImportIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItem, {
                    title: "In your browser",
                    description: "Capture snippets from Safari and Chrome.",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserIcon, {})
                })
            ]
        })
    }));
};
var FeatureItem = function(param) {
    var title = param.title, description = param.description, icon = param.icon;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "max-w-56 space-y-5 flex flex-col items-center text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[40px] h-[40px]",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-base text-white font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-white text-opacity-70",
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
;// CONCATENATED MODULE: ./components/google-analytics/google-analytics.tsx



var GOOGLE_ANALYTICS_ID = "G-TDJCZM4HVX";
var GoogleAnalytics = function() {
    if (!GOOGLE_ANALYTICS_ID) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                id: "google-analytics-init",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '".concat(GOOGLE_ANALYTICS_ID, "', {\n              page_path: window.location.pathname,\n            });\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                id: "google-analytics",
                strategy: "afterInteractive",
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(GOOGLE_ANALYTICS_ID)
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/google-analytics/index.ts


;// CONCATENATED MODULE: ./site-v2/home/icons/thoughts-connected.tsx


var ThoughtsConnnectedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: 15,
                y: 15,
                width: 20,
                height: 20,
                rx: 3,
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.2,
                d: "M14 30h-1a3 3 0 01-3-3V13a3 3 0 013-3h14a3 3 0 013 3v1",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.2,
                d: "M9 25H8a3 3 0 01-3-3V8a3 3 0 013-3h14a3 3 0 013 3v1",
                stroke: "#fff",
                strokeWidth: 2
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/instant-access.tsx


var InstantAccessIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: 18,
                cy: 18,
                r: 11,
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.2,
                d: "M4 7a1 1 0 011-1h13a1 1 0 110 2H5a1 1 0 01-1-1zM4 33a1 1 0 011-1h13a1 1 0 110 2H5a1 1 0 01-1-1z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.914 25.086L26.5 23.672 23.672 26.5l1.414 1.414 2.828-2.828zm2.672 8.328a2 2 0 102.828-2.828l-2.828 2.828zm-5.5-5.5l5.5 5.5 2.828-2.828-5.5-5.5-2.828 2.828z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: 0.2,
                fill: "#fff",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.998 25.938A1 1 0 0018 25h-3.876c1.148.637 2.47 1 3.876 1 .338 0 .671-.021.998-.062zM19 27.95A9.97 9.97 0 0110.859 25H5a1 1 0 00-1 1v2a1 1 0 001 1h13a1 1 0 001-1v-.05z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.07 22H18a1 1 0 001-1v-2a1 1 0 00-1-1h-8c0 1.457.39 2.823 1.07 4zM8.832 22A9.966 9.966 0 018 18H5a1 1 0 00-1 1v2a1 1 0 001 1h3.832z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.2,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.582 15H18a1 1 0 001-1v-2a1 1 0 00-1-1h-3.876a8.03 8.03 0 00-3.543 4zm-2.124 0a9.995 9.995 0 012.4-4H5a1 1 0 00-1 1v2a1 1 0 001 1h3.458z",
                fill: "#fff"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/integrated.tsx


var IntegratedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 13V8a3 3 0 013-3h24a3 3 0 013 3v18a3 3 0 01-3 3H21",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M5 19a2 2 0 012-2h8a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V19z",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29 35h-8M35 25H21",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M11.01 31H11",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 29l1 6",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/icons/secure.tsx


var SecureIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 13l14-8 14 8v5.858A16.306 16.306 0 0120 35v0A16.306 16.306 0 016 18.858V13z",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M23 19v-2a3 3 0 00-3-3v0a3 3 0 00-3 3v2",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: 0.4,
                d: "M15 24a3 3 0 003 3h4a3 3 0 003-3v-4H15v4z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 2
            })
        ]
    });
};

;// CONCATENATED MODULE: ./site-v2/home/product.tsx







var Product = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative -top-20",
                id: "product"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center md:space-y-10 space-y-10 px-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-6xl rounded-3xl relative shadow-inner-white drop-shadow-md",
                        style: {
                            background: 'radial-gradient(100% 100% at 50% 0%, #4E28B7 48.71%, #9726D5 100%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-xl w-full md:pl-16 md:py-20 p-10 space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[#D2BDFF] font-semibold text-lg",
                                        children: "Networked notetaking"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-white font-bold text-4xl",
                                        children: "Give your brain superpowers"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white text-opacity-75",
                                        children: "Associate notes using backlinks, mirroring the way your mind works. Trace associations to give you instant recall."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-10 space-y-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-6 leading-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-10 h-10",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThoughtsConnnectedIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-white font-semibold",
                                                                children: "Your thoughts connected"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-white text-opacity-75",
                                                                children: "Use backlinking technology to link and recall notes."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-6 leading-none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-10 h-10",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantAccessIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-white font-semibold",
                                                                children: "With instant access"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-white text-opacity-75 leading-tight",
                                                                children: "Retrieve and search your notes instantly. Online or offline."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 right-0 bottom-1/4 left-2/4 z-0 pointer-events-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/static/home/product-dots.png",
                                    layout: "fill",
                                    objectFit: "cover",
                                    objectPosition: "center"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-aos": "fade-right",
                                className: "absolute top-20 right-20 z-0 pointer-events-none hidden md:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/static/home/product-connections.png",
                                    width: 920 / 2,
                                    height: 586 / 2
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-aos": "fade-left",
                                className: "hidden md:block absolute top-80 right-32 z-0 pointer-events-none bg-gradient-to-b from-[#7653DA] to-[#6943D6] rounded-xl p-2 shadow-inner-white drop-shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "left-[23px] top-3 h-12 absolute w-[2px] bg-[#F5E5FF66] bg-opacity-40"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-3 text-sm leading-tight max-w-52",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-8 h-8 relative rounded-lg overflow-hidden drop-shadow",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: "/static/home/product-enrichment-avatar.png",
                                                            layout: "fill",
                                                            objectFit: "cover"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-[#ECE5FF] font-semibold",
                                                                children: "Alex MacCaw"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                className: "text-white text-opacity-75",
                                                                children: "Chairman"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-8 h-8 relative rounded-lg overflow-hidden drop-shadow",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: "/static/home/product-enrichment-company.png",
                                                            layout: "fill",
                                                            objectFit: "cover"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-[#ECE5FF] font-semibold",
                                                                children: "Clearbit"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                className: "text-white text-opacity-75",
                                                                children: "Know your customers. Win your market."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-6xl md:min-h-xl rounded-3xl relative flex flex-col items-center overflow-hidden shadow-inner-white drop-shadow-md",
                        style: {
                            background: 'radial-gradient(99.21% 99.21% at 50% 0%, #B23BA6 0%, #7D20CF 65.66%, #200B9F 100%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 z-0 pointer-events-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/static/home/product-crm-lines.png",
                                    layout: "fill",
                                    objectFit: "cover",
                                    objectPosition: "center"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-xl w-full px-16 py-20 space-y-4 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[#FFCBFF] font-semibold text-lg",
                                        children: "CRM"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-white font-bold text-4xl",
                                        children: "Improve your network"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white text-opacity-75",
                                        children: "Easily pull up a running list of your meeting-notes and conversations with people."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-aos": "fade-up",
                                className: "absolute top-72 hidden md:flex items-center px-10 transform-gpu",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-5xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/static/home/product-crm-shot.png",
                                        width: 2502 / 2,
                                        height: 1322 / 2,
                                        layout: "intrinsic",
                                        quality: 100
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-6xl rounded-3xl relative flex flex-col items-end overflow-hidden shadow-inner-white drop-shadow-md",
                        style: {
                            background: 'radial-gradient(100% 100% at 50% 0%, #210CA0 48.71%, #266CD5 100%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute left-0 top-0 bottom-0 right-[50%] hidden md:flex flex-col items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/static/home/product-research-background.png",
                                            layout: "fill",
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-aos": "zoom-in-up",
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/static/home/product-research-search-ui.png",
                                            width: 808 / 2,
                                            height: 746 / 2,
                                            layout: "intrinsic"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-xl w-full md:pl-10 md:pr-16 md:py-20 p-10 space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[#B2BCFF] font-semibold text-lg",
                                        children: "Research"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-white font-bold text-4xl",
                                        children: "Centralize your research"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white text-opacity-75",
                                        children: "Pull in your Kindle highlights, web snippets, and notes into one place. Blazing-fast search at your fingertips."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-10 space-y-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-6 leading-tight",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-10 h-10",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegratedIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-white font-semibold",
                                                                children: "Integrated with your devices"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-white text-opacity-75",
                                                                children: "We are where you are, mobile or desktop, online or offline. And we keep everything in sync."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex space-x-6 leading-tight",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-none w-10 h-10",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureIcon, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                className: "text-white font-semibold",
                                                                children: "Secure but open"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-white text-opacity-75",
                                                                children: "End-to-end encryption keeps your notes secure. Our export and API keeps your notes accessible."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/tweet-rotator/tweets.json
var tweet_rotator_tweets = __webpack_require__(43375);
// EXTERNAL MODULE: ./node_modules/lodash/sampleSize.js
var sampleSize = __webpack_require__(42404);
var sampleSize_default = /*#__PURE__*/__webpack_require__.n(sampleSize);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./site-v2/home/social-proof.tsx






var SocialProof = function() {
    var tweets = sampleSize_default()(tweet_rotator_tweets, 9);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative my-10 md:my-32 flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 pointer-events-none z-0 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/static/home/social-proof-stars.png",
                    width: 2448,
                    height: 888,
                    layout: "intrinsic"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-aos": "fade-up",
                className: "absolute inset-0 pointer-events-none z-0 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/static/home/social-proof-woosh.png",
                    width: 2260 / 2,
                    height: 888 / 2,
                    layout: "intrinsic"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center space-y-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "md:text-5xl text-4xl font-bold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "bg-clip-text text-transparent bg-gradient-to-r from-[#C3D4FF] via-white to-[#70B2FF]",
                            children: "Loved by thinkers"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-[#B1B2DD] text-xl",
                        children: "Here's what people are saying about us"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                    columns: 3,
                    children: tweets.map(function(tweet) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TweetItem, {
                            tweet: tweet
                        }, tweet.url);
                    })
                })
            })
        ]
    }));
};
var Grid = function(param) {
    var columns = param.columns, children = param.children;
    var items = react.Children.toArray(children);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex space-x-5 overflow-auto",
        children: times_default()(columns, function(i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "flex-none flex flex-row md:flex-col space-x-5 md:space-x-0 md:space-y-5",
                children: items.slice(i * columns, (i + 1) * columns)
            }, i);
        })
    }));
};
var TweetItem = function(param) {
    var tweet = param.tweet;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#1A1738] drop-shadow-md shadow-inner-white rounded-lg p-4 flex relative bg-opacity-90 overflow-hidden flex-none max-w-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/components/tweet-rotator/".concat(tweet.handle, ".jpg"),
                    width: 32,
                    height: 32,
                    className: "rounded-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-4 space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-1.5 font-semibold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#DBE6FF]",
                                children: tweet.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[#9893E3]",
                                children: [
                                    "@",
                                    tweet.handle
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#B1B2DD]",
                        children: tweet.body
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./site-v2/home/pricing.tsx




var Pricing = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:my-24 mt-10 relative flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative -top-32",
                id: "pricing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/static/home/pricing-bg.png",
                    layout: "intrinsic",
                    width: 2880 / 2,
                    height: 1694 / 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center relative space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-4 px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[#8A88FF] font-semibold",
                                children: "Get access"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "font-bold md:text-3xl text-2xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-[#C3C1FF] via-white to-[#C3C1FF]",
                                    children: [
                                        "We like keeping things simple.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " One plan one price."
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-none flex items-center space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-5xl text-purple-200",
                                        children: "$15"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#B1B2DD]",
                                        children: "/month"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3 text-white mt-5 md:mt-0 md:ml-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Networked note-taking"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "End to end encryption"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Offline sync"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Kindle highlights sync"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Chrome and Safari web clipper"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "iOS app"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/checkout?confirm=true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "flex-none inline-block font-semibold text-white bg-gradient-to-b from-home-button-lg to-home-button-rg rounded-lg drop-shadow-lg px-4 py-2 shadow-inner-white transform active:translate-y-0.5 active:opacity-90 transition duration-100",
                                children: "Start your 14-day trial"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
var TickIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "flex-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "9",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 10L6.74542 11.3045C7.31053 12.2934 8.72832 12.3165 9.32528 11.3464L12 7",
                stroke: "#181038",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(14653);
;// CONCATENATED MODULE: ./site-v2/home/company.tsx



var Company = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-10 md:mt-32 md:mb-10 flex flex-col items-center p-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative -top-32",
                id: "company"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-none relative flex flex-col md:flex-row md:space-x-10 space-y-10 md:space-y-0 max-w-5xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 w-full rounded-3xl bg-white bg-opacity-10 relative",
                        style: {
                            background: 'linear-gradient(99deg, #402247 44.26%, #A742E6 69.14%, #262247 96.8%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-[1px] right-[1px] bottom-[1px] left-[1px] bg-home-back rounded-3xl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-12 pb-32 space-y-10 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[#AC38AB] font-semibold",
                                            children: "About"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-white text-3xl",
                                            children: "We're an indie team dotted across the globe"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[#B1B2DD]",
                                            children: "Our mission is to improve the way people think by making the world's best noteworked note-taking app."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-12 left-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "border border-[#9D40D8] text-[#C364FF] font-semibold text-sm rounded-lg px-4 py-2 cursor-pointer inline-flex space-x-2 items-center hover:ring-purple-600 hover:ring-opacity-50 hover:ring transition duration-500",
                                    href: "https://reflect.academy/our-values",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "See our values"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                            width: 18,
                                            height: 18
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 w-full rounded-3xl bg-white bg-opacity-10 relative",
                        style: {
                            background: 'linear-gradient(104.28deg, #262247 1.24%, #395CC8 32.96%, #262247 68.22%)'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-[1px] right-[1px] bottom-[1px] left-[1px] bg-home-back rounded-3xl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-12 pb-32 space-y-10 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[#4A79FF] font-semibold",
                                            children: "Academy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-white text-3xl",
                                            children: "Learn how to take great notes at our academy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[#B1B2DD]",
                                            children: "Master the principles of note-taking in Reflect's free online Academy."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-12 left-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "border border-[#4A79FF] text-[#678FFF] font-semibold text-sm rounded-lg px-4 py-2 cursor-pointer space-x-2 inline-flex items-center hover:ring transition duration-500",
                                    href: "http://reflect.academy",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Take the course"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronRightIcon */.XCv, {
                                            width: 18,
                                            height: 18
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./site-v2/shared/meta.tsx
var meta = __webpack_require__(45386);
;// CONCATENATED MODULE: ./site-v2/home.tsx













var Home = function() {
    (0,react.useEffect)(function() {
        aos_default().init({
            once: true,
            disable: 'phone',
            duration: 700,
            easing: 'ease-out-cubic'
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAnalytics, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* Meta */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "site flex flex-col min-h-screen overflow-hidden bg-home-back text-white font-sans",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialProof, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Company, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                        ]
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 45386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Meta = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: "Reflect keeps track of your thoughts, books, and meetings."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: "Reflect keeps track of your thoughts, books, and meetings."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@reflectnotes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "https://reflect.app/static/twitter-card.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:title",
                content: "Reflect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image",
                content: "https://reflect.app/static/twitter-card.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:url",
                content: "https://reflect.app"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: "Reflect"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "https://reflect.app/static/icons/1024x1024.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "https://reflect.app/static/icons/180x180.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "512x512",
                href: "https://reflect.app/static/icons/512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "1024x1024",
                href: "https://reflect.app/static/icons/1024x1024.png"
            })
        ]
    });
};


/***/ }),

/***/ 43375:
/***/ (function(module) {

module.exports = JSON.parse('[{"name":"Sam Jenkins","handle":"samjenkins1987","body":"@reflectnotes is probably the best new product I\'ve used this year. Clearly made by a team that understand product. The little nuances, the simplicity and the automation of common daily workflows is life-changing. Well played @maccaw this is a sensational product 🙌","url":"https://twitter.com/samjenkins1987/status/1437728731166957569"},{"name":"Flour storm","handle":"adnan_wahab_","body":"@maccaw holy shit reflect app design is so good my writing and introspective ability went up 10x since i got it. was using bear/notion before but the simplicity of reflect is beautiful.","url":"https://twitter.com/adnan_wahab_/status/1436313580203352064"},{"name":"demetria r giles","handle":"drosewritings","body":"Playing around with @reflectnotes. I’m back logging key thoughts, details and soundbites from episodes, books, meetings, articles, etc from the past week. So far, it’s a knowledge worker’s dream come true. 🧠👍🏽","url":"https://twitter.com/drosewritings/status/1433833256118472704"},{"name":"Jeremy McPeak","handle":"jwmcpeak","body":"I just received an invite to @reflectnotes, and holy crap! It is well thought out, and I can see this being my note-taking platform going forward. Well done! I\'m looking forward to seeing how the app progresses.","url":"https://twitter.com/jwmcpeak/status/1434235538312208386"},{"name":"Sean Rose","handle":"seanrose","body":"Really, really liking @reflectnotes so far. It\'s just the right amount of simple/fast for a personal note taking app and does most of the hard work of organizing in the background.","url":"https://twitter.com/seanrose/status/1426290415414562819"},{"name":"Jonathan Simcoe","handle":"jdsimcoe","body":"All righty. I have to give a massive shout-out to @maccaw for pioneering @reflectnotes. It has already matured to a point where it is a daily driver for me. The speed, focus, and attention to detail (especially perfect bits of structured data) is superb.","url":"https://twitter.com/jdsimcoe/status/1425986232941572099"},{"name":"Ryan Delk","handle":"delk","body":"Don’t take it from me: @reflectnotes is magic.","url":"https://twitter.com/delk/status/1423704014370197506"},{"name":"Chris","handle":"Mr_Chris_L","body":"Absolutely loving @reflectnotes. The visualisation of the neural network is superb and seeing it develop makes me want to take daily notes. The back-linking makes associations effortless. Hats off to @maccaw and his team, it’s exactly what I’ve been looking for🙏","url":"https://twitter.com/Mr_Chris_L/status/1423281718342029319"},{"name":"Fabrizio Rinaldi","handle":"linuz90","body":"I’m keeping @reflectnotes open *all* the time, and I’m using both for simple journaling, and long form writing. It’s rare to see a single app work so well for both.","url":"https://twitter.com/linuz90/status/1423040168022380547"}]');

/***/ })

}]);